import styled from 'styled-components';
import { notification, Table } from 'antd';
import { Preloader } from '../../shared/components/preloader/Preloader';
import { useEffect, useState } from 'react';
import selectors from '../../redux/selectors/selectors';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getStatusPages } from '../../redux/actions/statusPageActions';
import { getUiDateShort } from '../../shared/lib/dates';
import {
  ActionIcon,
  Body,
  Container,
  Head,
  TableCellAction,
  TableCellActions,
  Title,
} from 'shared/styled/styled';
import { Icon } from '../../shared/components';
import { del, put } from '../../redux/lib/api';
import BasicSlideOut from '../../shared/components/BasicSlideOut';
import useBoundForm from '../../shared/hooks/useBoundForm';
import BoundFormGroup from '../../shared/components/boundForm/BoundFormGroup';

const StyledStatusPagesTable = styled.div`
  width: 100%;
  padding: 12px 36px 36px;
`;

export function StatusPagesTable() {
  const navigate = useNavigate();
  const isInitializing = useSelector(selectors.isInitializing);

  const [isLoading, setIsLoading] = useState(true);
  const statusPages = useSelector(selectors.statusPages);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const editForm = useBoundForm({});
  const [editStatusPageId, setEditStatusPageId] = useState('');

  const cellClick = (record) => {
    return {
      onClick: (_event) => {
        navigate(`/status/${record.id}`);
      },
      style: { cursor: 'pointer' },
    };
  };

  const editStatusPage = () => {
    put(`status_page/${editStatusPageId}`, {
      data: editForm.state,
    }).then((response) => {
      if (response) {
        notification.success({
          message: 'Success',
          description: 'Status page edited',
        });
      }
      getStatusPages().then(() => {
        setShowEditModal(false);
      });
    });
  };

  const deleteStatusPage = () => {
    del(`status_page/${editStatusPageId}`).then((response) => {
      if (response) {
        notification.success({
          message: 'Success',
          description: 'Status page deleted',
        });
      }
      getStatusPages().then(() => {
        setShowDeleteModal(false);
      });
    });
  };

  useEffect(() => {
    setIsLoading(true);
    getStatusPages().then(() => {
      setIsLoading(false);
    });
  }, [isInitializing]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'friendly_name',
      fixed: 'left',
      onCell: cellClick,
    },
    {
      title: 'Created At',
      render: (statusPage) => {
        return getUiDateShort(statusPage.created_at);
      },
      onCell: cellClick,
    },
    {
      title: 'Actions',
      width: '11%',
      render: (statusPage) => {
        return (
          <TableCellActions>
            <TableCellAction
              onClick={() => {
                editForm.setState({
                  friendly_name: statusPage.friendly_name,
                });
                setEditStatusPageId(statusPage.id);
                setShowEditModal(true);
              }}>
              <ActionIcon>
                <Icon name="pencil" />
              </ActionIcon>
            </TableCellAction>

            <TableCellAction
              onClick={() => {
                setEditStatusPageId(statusPage.id);
                setShowDeleteModal(true);
              }}>
              <ActionIcon>
                <Icon name="cross" />
              </ActionIcon>
            </TableCellAction>
          </TableCellActions>
        );
      },
      fixed: 'right',
    },
  ];

  const editFields = [
    [
      {
        id: 'friendly_name',
        label: 'Name',
        required: true,
        autoFocus: true,
      },
    ],
  ];

  return (
    <>
      <BasicSlideOut
        showSlideOut={showDeleteModal}
        hideSlideOut={() => {
          setShowDeleteModal(!showDeleteModal);
        }}
        title={'Delete Status Page'}
        body={
          <div style={{ width: '100%', textAlign: 'center' }}>
            <div>Are you sure you want to delete?</div>
          </div>
        }
        submitText={'Delete'}
        onSubmit={deleteStatusPage}
      />

      <BasicSlideOut
        showSlideOut={showEditModal}
        hideSlideOut={() => {
          setShowEditModal(!showEditModal);
        }}
        title={'Edit Status Page'}
        body={
          <BoundFormGroup
            formId={editForm.id}
            fields={editFields}
          />
        }
        submitText={'Edit'}
        onSubmit={editStatusPage}
      />

      <Container>
        {isLoading && <Preloader over />}
        <Head>
          <Title>Status Pages</Title>
        </Head>
        <Body>
          <StyledStatusPagesTable>
            <Table
              pagination={{
                hideOnSinglePage: true,
                defaultPageSize: 10,
                showSizeChanger: false,
                position: ['bottomRight'],
              }}
              rowKey={(record) => record.id}
              dataSource={statusPages}
              columns={columns}
              scroll={{ x: 'max-content' }}
            />
          </StyledStatusPagesTable>
        </Body>
      </Container>
    </>
  );
}
